import OperatorTableContainer from "../../../shared/OperatorDetails/OperatorTableContainer";
export const operatorData = [
  {
    date: "24.08.2025",
    hours: 8,
    prijn: 5,
    zDopom: 3,
    krosiv: 2,
    summaDopP: 120,
    percentDopP: 15,
    serCheck: 350,
    leadsPerHour: 2,
    earned: 1500,
  },
  {
    date: "25.08.2025",
    hours: 7,
    prijn: 4,
    zDopom: 2,
    krosiv: 1,
    summaDopP: 100,
    percentDopP: 12,
    serCheck: 300,
    leadsPerHour: 1.8,
    earned: 1300,
  },
  {
    date: "26.08.2025",
    hours: 9,
    prijn: 6,
    zDopom: 4,
    krosiv: 3,
    summaDopP: 140,
    percentDopP: 18,
    serCheck: 400,
    leadsPerHour: 2.5,
    earned: 1600,
  },
];
export default function OperatorTable() {
  return <OperatorTableContainer operatorData={operatorData} />;
}
